import FullGrid from "../components/full-grid";
import SectionGrid from "../components/section-grid";

export function DefaultFullGrid({ laneIndex, totalLanes }: { laneIndex: number; totalLanes: number }) {
	 return <FullGrid laneIndex={laneIndex} totalLanes={totalLanes} />
}

export const DefaultSectionGrid = ({ index }: { index: number }) => <SectionGrid index={index} />;